const Loader = Symbol('Loading row');

export const getLoadingRows = (count = 5): { id: number; [Loader]: true }[] => {
  return [...Array(count)].map(() => ({
    id: Math.random(),
    [Loader]: true,
  }));
};

export const isLoadingRow = (row: any): boolean => {
  return row[Loader];
};
